import React from 'react'

function Booking() {
  return (
    <div className="flex-grow overflow-y-auto bg-white">
    Booking

    </div>
  )
}

export default Booking